import axios from "@/request";
import qs from "qs";

export default {
  /* 人员详情 */
  async info(params: any) {
    return axios.get("invest-team/info", { params });
  },

  /* 团队人员列表 */
  async list(params: any) {
    return axios.get("invest-team/list", { params });
  },

  /* 成员场馆列表 */
  async list_stadium(params: any) {
    return axios.post("invest-team/list-stadium", qs.stringify(params));
  },

  /* 投资经理所有有效场馆 */
  async my_stadiums(params: any) {
    return axios.post("invest-team/my_stadiums", qs.stringify(params));
  },

  /* 设置在职｜离职 */
  async setup_job(params: any) {
    return axios.post("invest-team/setup-job", qs.stringify(params));
  },
}
